export const displayOptionValues = ({ size, color }, separator = ' • ') => {
  if (!size && !color) return null;
  if (!size && color) return color;
  if (!color && size) return size;
  return `${size}${separator}${color}`;
};
